// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"493": "0497264b7072f9c1","608": "19333a276846669c",}[chunkId] + ".js"
}